import React from 'react'

const Notify = ({ top = 'top-0.5', right = 'right-0' }: { top?: string, right?: string }) => {
  return (
    <span
        className={`absolute z-10 h-2 w-2 rounded-full bg-orange-400 flex ${top} ${right}`}
    >
        <span className='absolute inline-flex w-full h-full bg-orange-400 rounded-full opacity-75 animate-ping'></span>
    </span>
  )
}

export default Notify